// #e5effb background color for section
import "./styles/pageSeven.css"

function OurPartners() {
  return (
    <section className="page-7-container">
      <h2>Our Partners</h2>
      <div className="page-7-partners-logo">
        <img src="https://pillup.com/assets/Partners/emoha.png" alt="partners-logo-1" />
        <img src="https://pillup.com/assets/Partners/asli.png" alt="partners-logo-2" />
        <img src="https://pillup.com/assets/Partners/meradoc.png" alt="partners-logo-3" />
        <img src="https://pillup.com/assets/Partners/kochharcare.png" alt="partners-logo-4" />
      </div>
    </section>
  );
}

export default OurPartners;